<template>
  <div class="terminal" />
</template>

<script>
  import { Terminal } from 'xterm'
  import api from '@/api'
  import logger from '@/logger'

  export default {
    name: 'Terminal',
    props: {
      entity: {
        type: Object,
        required: true,
      },
      cols: {
        type: Number,
        required: false,
        default: 110,
      },
      rows: {
        type: Number,
        required: false,
        default: 40,
      },
    },
    data() {
      return {
        connected: false,
        options: {
          cancelEvents: true,
          cursorBlink: false,
          screenKeys: true,
          useStyle: false,
          cols: this.cols,
          rows: this.rows,
        },
      }
    },
    computed: {
      initOptions() {
        return {
          id: this.entity.id,
          type: this.entity.target,
          cols: this.options.cols,
          rows: this.options.rows,
        }
      }
    },
    watch: {
      connected(value) {
        this.$options.terminal.clear();
        if (value) {
          this.$options.terminal.focus();
        } else {
          this.$options.terminal.writeln('')
          this.$options.terminal.writeln('Connection lost!')
          this.$options.terminal.writeln('Reconnecting...')
        }
      }
    },
    sockets: {
      disconnect() {
        this.connected = false
      },
      reconnect() {
        this.start()
      },
      termData(data) {
        this.connected = true
        this.$options.terminal.write(data);
      },
      termEnd() {
        logger.event('🚧 Terminal session closed')
        this.$emit('termEnd')
      },
    },
    methods: {
      start() {
        logger.event('📢 init/term', this.initOptions)
        this.$options.terminal.writeln(`Establishing ${this.entity.target} control...`)
        api.socket.emit('init/term', this.initOptions)
      },
      stop() {
        this.$options.terminal.writeln('')
        this.$options.terminal.writeln('Closing...')
        api.socket.emit('deinit/term')
      },
    },
    mounted() {
      this.$options.terminal = new Terminal(this.options)
      this.$options.terminal.onData(data => {
        api.socket.emit('termData', data)
      })
      setTimeout(() => {
        this.$options.terminal.open(this.$el)
        this.start()
      }, 500)
    },
    beforeDestroy() {
      this.stop()
    },
    destroyed() {
      this.$options.terminal.dispose()
    },
  }
</script>

<style scoped>
  .terminal { background-color: #000; font-family: "courier-new, courier, monospace"; }
</style>
